import { Routes } from '@angular/router';
import { RoutePath } from '@tgbot/app/enums/route-path.enum';

import { UserGroup } from './auth/models/user.model';
import { FEATURE_FLAGS } from './constants/feature-flags.constant';
import { featureFlagGuard } from './guards/feature-flag.guard';
import { authGroupGuard } from './guards/group.guard';
import { guestGuard } from './guards/guest.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { accountInfoResolver } from './pages/account-info/resolvers/account-info.resolver';
import { LoginComponent } from './pages/login/login.component';
import { ShellComponent } from './pages/shell/shell.component';

export const routes: Routes = [
  {
    path: RoutePath.Login,
    component: LoginComponent,
    canActivate: [guestGuard],
    title: 'Login',
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGroupGuard([UserGroup.AccessManager, UserGroup.Admin, UserGroup.Manager])],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./components/redirect/redirect.component').then((m) => m.RedirectComponent),
        title: 'CRM',
      },
      {
        path: RoutePath.AccountCreation,
        canActivate: [authGroupGuard([UserGroup.Admin, UserGroup.AccessManager])],
        loadComponent: () =>
          import('./pages/telegram-account/telegram-account.component').then((m) => m.TelegramAccountComponent),
        title: 'Account creation',
      },
      {
        path: RoutePath.AccountManagement,
        canActivate: [authGroupGuard([UserGroup.Admin, UserGroup.AccessManager, UserGroup.Manager])],
        loadComponent: () =>
          import('./pages/account-management/account-management.component').then((m) => m.AccountManagementComponent),
        title: 'Account management',
      },
      {
        path: RoutePath.AccountManagement + '/:id',
        canActivate: [authGroupGuard([UserGroup.Admin, UserGroup.AccessManager, UserGroup.Manager])],
        resolve: { account: accountInfoResolver },
        loadComponent: () => import('./pages/account-info/account-info.component').then((m) => m.AccountInfoComponent),
        title: 'Account info',
      },
      {
        path: RoutePath.AccountAssignment,
        canActivate: [authGroupGuard([UserGroup.Admin, UserGroup.AccessManager])],
        loadComponent: () =>
          import('./pages/account-assignment/account-assignment.component').then((m) => m.AccountAssignmentComponent),
        canDeactivate: [unsavedChangesGuard],
        title: 'Account assignment',
      },
      {
        path: RoutePath.MassMessaging,
        canActivate: [
          authGroupGuard([UserGroup.Admin, UserGroup.AccessManager, UserGroup.Manager]),
          featureFlagGuard(FEATURE_FLAGS.massMessaging),
        ],
        loadComponent: () =>
          import('./pages/mass-messaging/mass-messaging.component').then((m) => m.MassMessagingComponent),
        title: 'Mass messaging',
      },
    ],
  },
  {
    path: RoutePath.NotFound,
    loadComponent: () => import('./pages/error-page/error-page.component').then((m) => m.ErrorPageComponent),
    title: 'Page not found',
    data: {
      code: 404,
      title: 'Page not found',
      description: "Oops! The page you're looking for doesn't seem to exist",
    },
  },
  {
    path: RoutePath.NoAccess,
    loadComponent: () => import('./pages/error-page/error-page.component').then((m) => m.ErrorPageComponent),
    title: 'Access denied',
    data: { code: 403, title: 'Access Denied', description: "You don't have permission to view this page." },
  },

  {
    path: '**',
    redirectTo: RoutePath.NotFound,
  },
];
